import { render, staticRenderFns } from "./LoginRoblox.vue?vue&type=template&id=34b37e8c&scoped=true"
import script from "./LoginRoblox.vue?vue&type=script&lang=js"
export * from "./LoginRoblox.vue?vue&type=script&lang=js"
import style0 from "./LoginRoblox.vue?vue&type=style&index=0&id=34b37e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b37e8c",
  null
  
)

export default component.exports